export const CeleryIcon = ({ size = 20 }: { size?: number }) => (
  <svg
    role='img'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    id='Celery--Streamline-Simple-Icons'
    height={size}
    width={size}
  >
    <desc>Celery Streamline Icon: https://streamlinehq.com</desc>
    <title>Celery</title>
    <path
      d='M2.303 0A2.298 2.298 0 0 0 0 2.303v19.394A2.298 2.298 0 0 0 2.303 24h19.394A2.298 2.298 0 0 0 24 21.697V2.303A2.298 2.298 0 0 0 21.697 0zm8.177 3.072c4.098 0 7.028 1.438 7.68 1.764l-1.194 2.55c-2.442 -1.057 -4.993 -1.41 -5.672 -1.41 -1.574 0 -2.17 0.922 -2.17 1.763v8.494c0 0.869 0.596 1.791 2.17 1.791 0.679 0 3.23 -0.38 5.672 -1.41l1.194 2.496c-0.435 0.271 -3.637 1.818 -7.68 1.818 -1.112 0 -4.64 -0.244 -4.64 -4.64V7.713c0 -4.397 3.528 -4.64 4.64 -4.64z'
      fill='#B6DE64'
      strokeWidth='1'
    ></path>
  </svg>
);